import {Component, ElementRef, inject, Input, OnInit, viewChild} from '@angular/core';
import {NgClass} from "@angular/common";
import {Notification} from "src/app/infrastructure/moovement-api/models/notification";
import {Asset} from "src/app/infrastructure/moovement-api/models/asset";
import {toReadableText} from "src/app/presentation/common/pipes/ToReadableTextPipe";
import {Router} from '@angular/router';
import {NotificationsService} from 'src/app/presentation/main-view/notifications/notification.service';
import {AssetsStore} from 'src/app/domain/assets/assets.store';

@Component({
  selector: 'app-notification',
  imports: [
    NgClass
  ],
  templateUrl: './notification.component.html',
  styleUrl: './notification.component.css'
})
export class NotificationComponent implements OnInit {

  @Input() notification?: Notification;
  @Input() asset?: Asset

  deleted = false;
  timestamp?: string
  text?: string;

  private el = viewChild.required<ElementRef<HTMLDivElement>>('notificationWrapper')

  private assetsStore = inject(AssetsStore);
  private router = inject(Router);
  private notificationsService = inject(NotificationsService);

  ngOnInit(): void {
    this.timestamp = new Date(this.notification?.issueTime!).toLocaleString();
    this.text = this.computeText();
  }

  open(): void {
    if (!this.asset) return;

    const url = this.assetsStore.assetIdToUrl(this.asset.id);
    if (!url) return;

    this.router.navigate([url, this.asset.id]);
  }

  delete(event: Event, notification: Notification) {
    event.stopPropagation();
    this.deleted = true;
    this.el().nativeElement.addEventListener('transitionend', () => {
      this.notificationsService.dismissNotification(notification);
    });
  }

  private computeText(): string {
    const name = this.asset?.name || this.asset?.id || '?';
    const message = this.toMessage(this.notification?.alertStatus || '', name);
    return toReadableText(message);
  }

  private toMessage(alertStatus: string, name: string): string {
    switch (alertStatus) {
      case 'OUT_OF_PADDOCK':
        return `${name} is out of paddock`;
      case 'OUT_OF_FARM':
        return `${name} is out of farm`;
      case 'STOPPED_MOVING':
        return `${name} has stopped moving`;
      case 'ABNORMALLY_LOW_ACTIVITY':
        return `${name} is much less active than usual`;
      case 'ABNORMALLY_HIGH_ACTIVITY':
        return `${name} is much more active than usual`;
      case 'SEEN_BY_UNEXPECTED_BLUETOOTH_SCANNER':
        return `${name} is seen by an unexpected scanner`
      default:
        return `${name} needs your attention!`;
    }
  }
}
